import { extend } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import CommentPost from 'flarum/forum/components/CommentPost';
import PostReactAction from './components/PostReactAction';
import PostReactionCounts from './components/PostReactionCounts';
import PostControls from 'flarum/forum/utils/PostControls';
import Button from 'flarum/common/components/Button';
export default () => {
  extend(CommentPost.prototype, 'footerItems', function (items) {
    const post = this.attrs.post;
    if (post.isHidden()) return;
    const reactionCounts = post.reactionCounts();
    const hasReactions = reactionCounts && Object.values(reactionCounts).some(c => c > 0);
    if (!hasReactions) return;
    items.add('reactionCounts', PostReactionCounts.component({
      post
    }), 10);
  });
  extend(CommentPost.prototype, 'actionItems', function (items) {
    const post = this.attrs.post;
    if (post.isHidden()) return;
    items.add('react', PostReactAction.component({
      post
    }), 5);
  });

  // Redraw a post if reaction counts have changed (needed for footer numbers to update).
  extend(CommentPost.prototype, 'oninit', function () {
    this.subtree.check(() => {
      var _this$post, _this$post$reactionCo;
      return (_this$post = this.post) == null || (_this$post$reactionCo = _this$post.reactionCounts) == null ? void 0 : _this$post$reactionCo.call(_this$post);
    });
  });
  extend(PostControls, 'moderationControls', function (items, post) {
    const reactionCounts = post.reactionCounts();
    const hasReactions = reactionCounts && Object.keys(reactionCounts).length > 0;
    if (post.discussion().canSeeReactions() && hasReactions) {
      items.add('viewReactions', m(Button, {
        icon: "fas fa-heart",
        onclick: () => app.modal.show(() => import(/* webpackChunkName: 'forum/components/ReactionsModal', webpackMode: 'lazy-once' */ './components/ReactionsModal'), {
          post
        })
      }, app.translator.trans('fof-reactions.forum.mod_item')));
    }
  });
};flarum.reg.addChunkModule('643', '860', 'fof-reactions', 'forum/components/ReactionsModal');
flarum.reg.addChunkModule('643', '860', 'fof-reactions', 'forum/utils/groupBy');
flarum.reg.addChunkModule('643', '860', 'fof-reactions', 'forum/states/ReactionsModalState');